export const TipoDomicilio = {
  FISCAL: 'Domicilio Fiscal',
  LEGAL: 'Domicilio Legal',
  REAL: 'Domicilio Real',
  ACTIVIDAD: 'Domicilio de Actividad'
}
